import { useState } from "react";

import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

import { useLogout } from "../../hooks/mutations/useLogout";

export const Logout = () => {
  const logoutMutation = useLogout();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const logout = () => {
    logoutMutation.mutate();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Tem certeza de que deseja sair?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancelar
          </Button>
          <Button onClick={logout} color="primary" autoFocus>
            Sair
          </Button>
        </DialogActions>
      </Dialog>

      <IconButton onClick={handleClickOpen}>
        <PowerSettingsNewIcon style={{ color: "white" }} />
      </IconButton>
    </>
  );
};
